import React from 'react';

const SectionHeader = ({ children, className = "" }) => {
  return (
    <div className={`text-lg sm:text-xl font-semibold text-black mb-4 ${className}`}>
      {children}
    </div>
  );
};

export default SectionHeader;
